import { ref, readonly } from 'vue';
import type { SnackbarStatus } from '../components/base/globalSnackbar/types';

const isVisible = ref(false);
const currentStatus = ref('');
const currentTextArray = ref<string[]>([]);

const statusToCssClassMap: Record<SnackbarStatus, string> = {
  success: 'success',
  error: 'error',
  info: 'info',
  warning: 'warning',
};

export function useGlobalSnackbar() {
  function show(status: SnackbarStatus, textArray: string[]) {
    currentStatus.value = statusToCssClassMap[status];
    currentTextArray.value = textArray;
    isVisible.value = true;
  }

  return {
    isVisible,
    currentStatus,
    currentTextArray,
    show,
  };
}
